const SDK_VERSION = "10.76.2" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
